import { useCallback } from 'react';
import { css } from '@emotion/react';
import { useContextTranslation } from '@core/i18n';
import { MAX_HORIZONTAL_PANEL_WIDTH } from '@embed/components/VideoPlayer/Player3/components/modals/shared/constants';
import { SubsList, SubsListItem, SubsListItemButton, } from '@embed/components/VideoPlayer/Player3/components/modals/shared/SubtitlesPanel/SubtitlesPanel.styles';
import { PlayerModal } from '@embed/components/VideoPlayer/Player3/components/PlayerModal';
import { useSubtitles } from '@embed/components/VideoPlayer/Player3/features/TextCues';
import { useSubtitlesLabel } from '@embed/components/VideoPlayer/Player3/features/TextCues/hooks/useSubtitlesLabel';
import { usePlayerLayout, VideoOrientation, } from '@embed/components/VideoPlayer/Player3/hooks/usePlayerLayout';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { useVideoPlayerStore } from '@embed/components/VideoPlayer/store';
import { videoPlayerIsFullscreenSelector } from '@embed/components/VideoPlayer/store/selectors';
import Modal from '@player/components/Modal';
import { DrawerPosition } from '@player/components/Modal/Drawer';
import { SUBTITLES_OFF_BUTTON, SUBTITLES_OPTION_BUTTON } from '@player/testIds';
/**
 * The Panel that displays subtitle options
 */
export function SubtitlesPanel({ onDismiss }) {
    const isFullscreen = useVideoPlayerStore(videoPlayerIsFullscreenSelector);
    const { videoOrientation } = usePlayerLayout();
    const maxWidth = isFullscreen && videoOrientation === VideoOrientation.HORIZONTAL
        ? MAX_HORIZONTAL_PANEL_WIDTH
        : undefined;
    const { currentSubtitles, subsAreEnabled, subtitles } = useSubtitles();
    const setCurrentSubtitlesId = useStore((state) => state.actions.setCurrentSubtitlesId);
    const setSubtitlesEnabled = useStore((state) => state.actions.setSubtitlesEnabled);
    const { t } = useContextTranslation();
    const handleSubTitlesOffClick = useCallback(() => {
        setSubtitlesEnabled(false);
        setCurrentSubtitlesId(null);
        onDismiss();
    }, [setSubtitlesEnabled, onDismiss, setCurrentSubtitlesId]);
    const handleSubtitlesClick = useCallback((id) => {
        setSubtitlesEnabled(true);
        setCurrentSubtitlesId(id);
        onDismiss();
    }, [setCurrentSubtitlesId, setSubtitlesEnabled, onDismiss]);
    const getSubtitlesLabel = useSubtitlesLabel();
    return (<PlayerModal onBackdropClick={onDismiss} closeButton={<Modal.ButtonClose onClick={onDismiss} aria-label={t('player:close subtitles panel')}/>}>
      <Modal.Drawer color="var(--player-modal-font-color)" backgroundColor="var(--player-modal-background)" position={DrawerPosition.BOTTOM} maxWidth={maxWidth} css={css `
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
        `}>
        <SubsList>
          <SubsListItem current={!subsAreEnabled}>
            <SubsListItemButton onClick={handleSubTitlesOffClick} data-testid={SUBTITLES_OFF_BUTTON}>
              {t('player:Off')}
            </SubsListItemButton>
          </SubsListItem>
          {subtitles.map((sub) => {
            return (<SubsListItem key={sub.id} current={subsAreEnabled && sub.id === currentSubtitles?.id}>
                <SubsListItemButton onClick={() => {
                    handleSubtitlesClick(sub.id);
                }} data-testid={SUBTITLES_OPTION_BUTTON}>
                  {getSubtitlesLabel(sub)}
                </SubsListItemButton>
              </SubsListItem>);
        })}
        </SubsList>
      </Modal.Drawer>
    </PlayerModal>);
}
